import React from 'react';

import { IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch } from 'react-router';

import { MAMA_PAGE_PAGE_PATH, MamaPage } from '../mama';
import { QR_PAGE_PATH, QrRedirectPage } from '../qr';
import { WINNERS_PAGE_PAGE_PATH, WinnersPage } from '../winner';

export const Page: React.FC = () => {
  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Switch>
          <Route path={QR_PAGE_PATH} component={QrRedirectPage} />
          {/* <Route path={RULES_PAGE_PAGE_PATH} component={RulesPage} /> */}
          <Route path={WINNERS_PAGE_PAGE_PATH} component={WinnersPage} />
          <Route path={MAMA_PAGE_PAGE_PATH} component={MamaPage} />
        </Switch>
      </IonRouterOutlet>
    </IonReactRouter>
  );
};
